export default {
    list(state) {
        return state.list;
    },
    order(state) {
        return state.order;
    }
}